/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import request from './request';

/**
 * 初始化请求拦截器
 * 从 localStorage 恢复 API key 并设置到请求头
 */
export function initRequestInterceptor() {
  try {
    const authData = localStorage.getItem('auth');
    if (authData) {
      const parsed = JSON.parse(authData);
      if (parsed.apiKey) {
        // 设置默认请求头
        request.setDefaultHeaders({
          'Authorization': parsed.apiKey,
          'x-api-key': parsed.apiKey,
        });
        console.log('✅ API Key 已恢复并配置到请求头');
      }
    }
  } catch (error) {
    console.error('初始化请求拦截器失败:', error);
  }
}

/**
 * 清除请求头中的 Authorization
 */
export function clearRequestAuth() {
  request.setDefaultHeaders({
    'Authorization': '',
    'x-api-key': '',
  });
  console.log('🔓 已清除请求认证信息');
}
